// ===== CHZM Lighting - Interactive Features =====

// 1. Sticky navbar shadow on scroll
const navbar = document.getElementById('navbar');
window.addEventListener('scroll', () => {
    if (window.scrollY > 50) {
        navbar.classList.add('scrolled');
    } else {
        navbar.classList.remove('scrolled');
    }
});

// 2. Mobile menu toggle
const navToggle = document.getElementById('navToggle');
const navMenu = document.querySelector('.nav-menu');
if (navToggle) {
    navToggle.addEventListener('click', () => {
        navMenu.classList.toggle('open');
        if (navMenu.classList.contains('open')) {
            navMenu.style.cssText = 'display: flex; flex-direction: column; position: absolute; top: 100%; left: 0; right: 0; background: #fff; padding: 20px; box-shadow: 0 8px 24px rgba(0,0,0,0.1);';
        } else {
            navMenu.style.cssText = '';
        }
    });
}

// 3. Smooth scroll for navigation links
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
        const target = this.getAttribute('href');
        if (target === '#' || target === '') return;
        const element = document.querySelector(target);
        if (element) {
            e.preventDefault();
            const offset = 80;
            const top = element.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({ top, behavior: 'smooth' });
            // Close mobile menu after click
            if (navMenu.classList.contains('open')) {
                navMenu.classList.remove('open');
                navMenu.style.cssText = '';
            }
        }
    });
});

// 4. Active nav link highlight on scroll
const sections = document.querySelectorAll('section[id], header[id]');
const navLinks = document.querySelectorAll('.nav-menu > li > a[href^="#"]');

function updateActiveNav() {
    const scrollPos = window.scrollY + 150;
    sections.forEach(section => {
        const top = section.offsetTop;
        const bottom = top + section.offsetHeight;
        const id = section.getAttribute('id');
        if (scrollPos >= top && scrollPos < bottom) {
            navLinks.forEach(link => {
                link.classList.remove('active');
                if (link.getAttribute('href') === '#' + id) {
                    link.classList.add('active');
                }
            });
        }
    });
}
window.addEventListener('scroll', updateActiveNav);

// 5. Fade-in animation on scroll (Intersection Observer)
const fadeElements = document.querySelectorAll('.fade-up');
const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
            // Stagger animation for elements in the same viewport
            setTimeout(() => {
                entry.target.classList.add('visible');
            }, index * 80);
            observer.unobserve(entry.target);
        }
    });
}, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

fadeElements.forEach(el => observer.observe(el));

// 6. Animated counter for hero stats
const counters = document.querySelectorAll('.hero-stat .number');
const counterObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            const target = entry.target;
            const finalValue = target.textContent;
            const numericValue = parseInt(finalValue.replace(/\D/g, ''));
            const suffix = finalValue.replace(/[0-9]/g, '');
            let current = 0;
            const increment = numericValue / 40;
            const timer = setInterval(() => {
                current += increment;
                if (current >= numericValue) {
                    current = numericValue;
                    clearInterval(timer);
                }
                target.textContent = Math.floor(current) + suffix;
            }, 30);
            counterObserver.unobserve(target);
        }
    });
}, { threshold: 0.5 });

counters.forEach(c => counterObserver.observe(c));

// 7. Form submission feedback enhancement
const form = document.querySelector('.contact-form');
if (form) {
    const submitBtn = form.querySelector('button[type="submit"]');
    const originalText = submitBtn.textContent;
    form.addEventListener('submit', (e) => {
        e.preventDefault();
        submitBtn.textContent = '✓ Sending...';
        submitBtn.style.opacity = '0.7';
        submitBtn.disabled = true;
        setTimeout(() => {
            submitBtn.textContent = '✓ Inquiry Sent!';
            submitBtn.style.opacity = '1';
            submitBtn.style.background = '#27ae60';
            setTimeout(() => {
                form.reset();
                submitBtn.textContent = originalText;
                submitBtn.style.background = '';
                submitBtn.disabled = false;
            }, 3000);
        }, 1500);
    });
}

// 8. Parallax effect for hero background (subtle)
const heroBg = document.querySelector('.hero-bg');
if (heroBg) {
    window.addEventListener('scroll', () => {
        const scrolled = window.scrollY;
        if (scrolled < window.innerHeight) {
            heroBg.style.transform = `translateY(${scrolled * 0.3}px)`;
        }
    });
}

// 9. Mega menu: click-to-expand on mobile, hover on desktop
const megaTrigger = document.querySelector('.megamenu-trigger');
const megaItem = document.querySelector('.has-megamenu');

if (megaTrigger && megaItem) {
    // On mobile (<=1024px): toggle expansion on click instead of navigating
    megaTrigger.addEventListener('click', function(e) {
        if (window.innerWidth <= 1024) {
            e.preventDefault();
            megaItem.classList.toggle('expanded');
        }
    });

    // Close mega menu when clicking outside (mobile)
    document.addEventListener('click', function(e) {
        if (window.innerWidth <= 1024 && !megaItem.contains(e.target)) {
            megaItem.classList.remove('expanded');
        }
    });
}

// Close mega menu dropdown when clicking a link inside it (desktop hover auto-closes, this is extra safety)
document.querySelectorAll('.megamenu a').forEach(link => {
    link.addEventListener('click', () => {
        megaItem.classList.remove('expanded');
    });
});

console.log('%c💡 CHZM Lighting Website', 'color: #C8102E; font-size: 18px; font-weight: bold;');
console.log('%cProfessional LED Manufacturer Since 1985', 'color: #d4a017; font-size: 12px;');

// 10. Hero Banner (single static image — no JS needed)
